import React from "react";
import { Container } from "react-bootstrap";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { GlobalSpinner } from "../../../../../global/globalFunctions";
import MaterialTable from "material-table";
import Button from '@mui/material/Button';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import moment from "moment";


const styles = {
    card: {
        border: "1px solid #ddd",
        borderRadius: "12px",
        padding: "10px",
        textAlign: "center",
        boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
        backgroundColor: "#81ABD3",
    },
    container: {
        display: "flex",
        gap: "15px",
        margin: "10px",
    },
    heading: {
        fontSize: "15px",
        fontWeight: "bold",
        marginBottom: "10px",
    },
    data: {
        fontSize: "13px",
        fontWeight: "600",
        color: "#333",
    },
};

const LTLedgerData = (props) => {

    const ledgerCards = [
        { title: "Employee Name", data: `${props.ltLedger?.employeeDetails?.employeeName || ""}` },
        { title: "Total Payment Amount", data: `${props.ltLedger?.debitSum || 0}` },
        { title: "Total Received Amount", data: `${props.ltLedger?.creditSum || 0}` },
        // { title: "Start Date - TEnd Date", data: `${searchAccountLedger.startDate} - ${searchAccountLedger.endDate}` || "" },
    ];

    return (
        <>
            {props.isFetchingLTLedger ? (
                <GlobalSpinner />
            ) : (
                <Container fluid>
                    <div style={{ textAlign: 'center', marginBottom: '25px' }}>
                        <Link to="/hr/longTerm/LTLedger">
                            <Button variant="contained" endIcon={<ArrowBackIcon />} size="large" > BACK TO SEARCH </Button>
                        </Link>
                    </div>

                    <div style={styles.container}>
                        {ledgerCards.map((card, index) => (
                            <div key={index} style={styles.card}>
                                <div style={styles.heading}>{card.title}</div>
                                <div style={styles.data}>{card.data}</div>
                            </div>
                        ))}
                    </div>

                    <div className="main">
                        <MaterialTable
                            title="Short Term Ledger"
                            columns={[
                                { title: "Date", field: "date", render: rowData => moment(rowData.date).format('DD-MM-YYYY') },
                                { title: "Payment Type", field: "accType" },
                                { title: "Description", field: "description" },
                                // { title: "Opening Balance", field: "openingBalance" },
                                { title: "Payment Amount", field: "debitValue" },
                                { title: "Received Amount", field: "creditValue" },
                                { title: "Closing Balance", field: "closingBalance" },
                            ]}
                            data={props.ltLedger.data}
                            options={{
                                actionsColumnIndex: -1,
                                exportButton: true,
                                exportAllData: true,
                                paging: true,
                                pageSize: 50,
                                emptyRowsWhenPaging: false,
                                pageSizeOptions: [50, 100, 150, 200],
                                headerStyle: {
                                    position: "sticky",
                                    top: 0,
                                    color: "#00BBBB",
                                    fontWeight: "550",
                                    onRowAdd: "none",
                                },
                            }}
                        />
                    </div>
                </Container>
            )}
        </>
    );
};

const mapDispatchToProps = (dispatch) => {
    return {

    };
};
const mapStateToProps = (state, ownProps) => ({
    ltLedger: state.LTReducer.ltLedger,
    isFetchingLTLedger: state.LTReducer.isFetchingLTLedger,
});

export default connect(mapStateToProps, mapDispatchToProps)(LTLedgerData);